import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItem = ({ id, section, editSection }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`rounded-lg border-gray-200 dark:border-gray-700 bg-dark dark:bg-gray-800 shadow-sm ${
        isDragging
          ? "opacity-50 border-indigo-500 ring-2 ring-indigo-500/20"
          : ""
      }`}
    >
      <div className="d-flex align-items-center justify-content-between px-2 py-4 rounded-lg w-100 bg-dark my-2 border ">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            {...attributes}
            {...listeners}
            className="cursor-grab active:cursor-grabbing p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          >
            <svg
              className="w-6 h-6 mx-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 8h16M4 16h16"
              />
            </svg>
          </div>
          <div className="mx-2">
            <div className="d-flex flex-column">
              <span className="text-light font-bold text-xl">
                {section.heading}
              </span>
              <span
                className="text-slate-500 font-bold"
                style={{ fontSize: "0.9rem" }}
              >
                {section?.section_type.toUpperCase()}
              </span>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <button
            onClick={() => {
              editSection(section);
            }}
            className="p-2 text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-md transition-colors"
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortableItem;
